import { Summary } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-result.type';

export type MetricValueCategory = 'weight' | 'daysWeeks' | 'fcr' | 'percentage' | 'gwp' | 'feedCostPerKg' | 'currency';

type MetricValueKey =
  | keyof Summary
  | 'feedCostTotal'
  | 'operationsCostTotal'
  | 'treatmentCostTotal'
  | 'smoltCostTotal'
  | 'harvestCostTotal';

const CATEGORY_DIGITS: Record<MetricValueCategory, { minimumFractionDigits: number; maximumFractionDigits: number }> = {
  weight: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  daysWeeks: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
  fcr: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  percentage: { minimumFractionDigits: 1, maximumFractionDigits: 1 },
  gwp: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  feedCostPerKg: { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  currency: { minimumFractionDigits: 0, maximumFractionDigits: 0 },
};

export const METRIC_VALUE_CATEGORY_BY_KEY: Partial<Record<MetricValueKey, MetricValueCategory>> = {
  finalWeightGrams: 'weight',
  weightGainGrams: 'weight',
  feedIntakeGrams: 'weight',
  hogGainGrams: 'weight',
  daysToReach: 'daysWeeks',
  bFcr: 'fcr',
  eFcr: 'fcr',
  carcassYieldPercent: 'percentage',
  filletFatPercent: 'percentage',
  globalWarmingPotentialCo2KgPerKgGrowth: 'gwp',
  globalWarmingPotentialCo2KgPerKgFeed: 'gwp',
  averageFeedCostPerKgFeed: 'feedCostPerKg',
  feedCostOfGrowth: 'feedCostPerKg',
  feedCostOfHogGain: 'feedCostPerKg',
  feedCostTotal: 'currency',
  operationsCostTotal: 'currency',
  treatmentCostTotal: 'currency',
  smoltCostTotal: 'currency',
  harvestCostTotal: 'currency',
  totalCost: 'currency',
  potentialSalesValue: 'currency',
  potentialProfit: 'currency',
};

export const getMetricValueCategory = (valueKey: string): MetricValueCategory | undefined =>
  METRIC_VALUE_CATEGORY_BY_KEY[valueKey as MetricValueKey];

export const getMetricValueDigits = (
  category: MetricValueCategory
): { minimumFractionDigits: number; maximumFractionDigits: number } => CATEGORY_DIGITS[category];

export const getMetricValueUnit = (category: MetricValueCategory, currency?: string): string => {
  const currencyCode = currency?.toUpperCase();
  switch (category) {
    case 'weight':
      return 'g';
    case 'percentage':
      return '%';
    case 'gwp':
      return 'kg';
    case 'feedCostPerKg':
      return currencyCode === 'NOK' ? 'NOK/kg' : 'USD/lb';
    case 'currency':
      return currencyCode ?? '';
    default:
      return '';
  }
};
